import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DragDropItem } from '../types/item';

type TypeList<Type> = {
  [key: string]: BehaviorSubject<Type[]>;
}[];

@Injectable()
export class DragDropContainerService<Type extends DragDropItem> {
  protected list: TypeList<Type> = [];

  constructor() {}

  addNewList(key: string, item: BehaviorSubject<Type[]>): void {
    this.removeList(key);
    this.list.push({ [key]: item });
  }
  removeList(key: string): void {
    this.list = this.list.filter((item) => !item[key]);
  }
  getList(key: string): BehaviorSubject<Type[]> {
    return this.list.find((item) => item[key])?.[key];
  }
  getAllLists(): TypeList<Type> {
    return this.list;
  }
}
